<div class="content-with-side-menu">
    <div class="row no-gutters">
        <div class="col-md-auto">
            <app-enrollment-report-search-criteria
                hznTestId="enrollment-report-filters"
                [filters]="filters"
                [searchForm]="searchForm"
            ></app-enrollment-report-search-criteria>
        </div>

        <div class="col">
            @if (!noItems && !isBusy) {
                <div
                    class="row no-gutters top-panel height-60 line-height-40 padding-10"
                >
                    <div class="col">
                        <button
                            class="btn btn-success"
                            bcClick
                            hznTestId="enrollment-report-generate"
                            (clicked)="getReport()"
                        >
                            {{ "EnrollmentReport.Generate" | translate }}
                        </button>
                    </div>
                </div>
            }

            <div>
                <bcu-local-spinner
                    [size]="50"
                    [visible]="isBusy"
                ></bcu-local-spinner>

                <div class="list-group list-group-flush grid">
                    @if (!noItems && !isBusy) {
                        <div
                            class="list-group-item list-group-item-action flex-column align-items-start grid-header"
                        >
                            <div class="row">
                                <div class="col-md-2 col-sm-2 grid-column">
                                    {{
                                        "EnrollmentReport.MemberIdHeader"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-3 col-sm-3 grid-column">
                                    {{
                                        "EnrollmentReport.FinalizedByHeader"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-3 col-sm-3 grid-column">
                                    {{
                                        "EnrollmentReport.ChildFullNameHeader"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-2 col-sm-2 grid-column">
                                    {{
                                        "EnrollmentReport.ClubHeader"
                                            | translate
                                    }}
                                </div>
                                <div class="col-md-2 col-sm-2 grid-column">
                                    {{
                                        "EnrollmentReport.PurchaseSetNumberHeader"
                                            | translate
                                    }}
                                </div>
                            </div>
                        </div>
                    }

                    @for (item of visibleItems; track item) {
                        <div
                            class="list-group-item list-group-item-action flex-column align-items-start clickable"
                        >
                            @if (!isBusy) {
                                <app-enrollment-report-item
                                    hznTestId="enrollment-report-row"
                                    [item]="item"
                                ></app-enrollment-report-item>
                            }
                        </div>
                    }
                    @if (!isBusy && visibleItems.length < (items?.length ?? 0)) {
                        <div class="padding-20">
                            <span>{{ "EnrollmentReport.ShowingRows" | translate: { shown: visibleItems.length, total: items.length } }}</span>
                            <button class="btn btn-secondary ml-2" bcClick (clicked)="showMore()">
                                {{ "EnrollmentReport.ShowMore" | translate }}
                            </button>
                        </div>
                    }
                    @if (noItems && !isBusy) {
                        <div class="no-items-info padding-20" hznTestId="enrollment-report-no-items">
                            <span>{{
                                "EnrollmentReport.NoItems" | translate
                            }}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
